import React, { Component } from 'react';
import { string, object, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { v4 as uuid } from 'uuid';
import _ from 'lodash';
import clsx from 'clsx';
import BigText from '../../../../components/LazyWidgets/BigText';
import Button from '../../../../components/LazyWidgets/Button';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import s from '../overviewWidget.module.css';
import sButton from '../../../../components/MLButton/MLButton.module.css';
import MLToolLaunchLink from '../../../components/MLToolLaunchLink';
import RevisionPlansCard from './RevisionPlans';
import { refreshReport as refreshReportAction } from '../../../actions/reports';

const InsightCard = (props) => {
  const handleButtonClick = () => {
    props.onTabChange(props.url);
  };
  const absPath = /^https?:\/\//i;
  const buttonStyle = props.isReflection
    ? [s.containerButton, s.secondButton].join(' ')
    : s.containerButton;
  let linkComponent;
  if (props.launchData) {
    props.launchData.name = props.textButton;
    linkComponent = (
      <MLToolLaunchLink
        data={props.launchData}
        linkLabel={props.textButton}
        className={[s.viewLink, sButton.btnSecondary].join(' ')}
        getLaunchUrl={props.getLaunchUrl}
      />
    );
  } else if (!absPath.test(props.url)) {
    linkComponent = (
      <Button onClick={handleButtonClick} theme="secondary">
        {props.textButton}
      </Button>
    );
  } else {
    linkComponent = (
      <a
        href={props.url}
        el="noopener noreferrer"
        className={[s.viewLink, sButton.btnSecondary].join(' ')}
      >
        {props.textButton}
      </a>
    );
  }

  return (
    <div className={clsx(s.OverviewSection, props.className)}>
      <div className={s.textDescription}>{props.textDescription}</div>
      <div className={s.containerCard}>
        {props.isReflection && (
          <div className={s.percentage}>
            <BigText className={s.bigNumber} text={`${props.number}%`} />
            <div className={s.percentageDescription}>
              disagree or strongly disagree
            </div>
          </div>
        )}
        <div className={buttonStyle}>{linkComponent}</div>
      </div>
    </div>
  );
};

InsightCard.propTypes = {
  onTabChange: func,
  url: string,
  launchData: object,
  isReflection: bool,
  textDescription: string,
  textButton: string,
  className: string,
  number: string,
  getLaunchUrl: func,
};

const SkillsNullState = (props) => {
  const {
    nullText,
    nullStateBtnLabel,
    onTabChange,
    url,
    launchData,
    getLaunchUrl,
  } = props;
  return (
    <InsightCard
      className={s.nullState}
      isReflection={false}
      onTabChange={onTabChange}
      textButton={nullStateBtnLabel}
      url={url}
      launchData={launchData}
      textDescription={nullText}
      getLaunchUrl={getLaunchUrl}
    />
  );
};

SkillsNullState.propTypes = {
  onTabChange: func,
  nullText: string,
  url: string,
  launchData: object,
  nullStateBtnLabel: string,
  getLaunchUrl: func,
};

class SkillsOverviewWidget extends Component {
  handleISGLaunch = (studentId) => {
    if (!studentId) return;
    const performanceUrl = `/courses/${this.props.reports.courseAbstract.shortId}/performance?studentId=${studentId}`;
    this.props.onTabChange(performanceUrl);
  };

  getNullStateData() {
    const {
      tool,
      assignmentId,
      activityId,
    } = this.props.reports.overviewWidget.revisionPlanCard;
    return {
      course_id: this.props.reports.courseAbstract.id,
      tool,
      activity_id: activityId,
      id: assignmentId,
    };
  }

  getWritingCreateData() {
    const {
      reports: { courseAbstract = {} },
    } = this.props;
    const assignmentId = uuid();
    return {
      course_id: courseAbstract.id,
      tool: 'writing',
      id: assignmentId,
      activity_id: 'new',
      productModelId: courseAbstract.productModelId,
      short_id: courseAbstract.shortId,
    };
  }

  renderInsights() {
    const reflectionDescription =
      'Did my students understand the criteria for feedback?';
    const reflectionBtnLabel = 'View Reflection Report';
    const nullTextAssignments =
      "We noticed you haven't created any writing assignments";
    const nullStateAssignmentsBtnLabel = 'Create Assignment';
    const nullTextNotSubmitted =
      'Students have not yet answered the reflection question for the current draft.';
    const nullNotSubmittedBtnLabel = 'View Writing Assignment';
    const {
      reflectionCard,
      revisionPlanCard,
      hasWritingActivity,
    } = this.props.reports.overviewWidget;
    const nullStateAssignments =
      !reflectionCard || _.isNull(reflectionCard.total) || !hasWritingActivity;
    const nullStateNotSubmitted =
      revisionPlanCard && reflectionCard && reflectionCard.total === 0;

    return (
      <div>
        {nullStateAssignments || nullStateNotSubmitted ? (
          <SkillsNullState
            nullText={
              !nullStateNotSubmitted
                ? nullTextAssignments
                : nullTextNotSubmitted
            }
            nullStateBtnLabel={
              !nullStateNotSubmitted
                ? nullStateAssignmentsBtnLabel
                : nullNotSubmittedBtnLabel
            }
            onTabChange={this.props.onTabChange}
            launchData={
              !nullStateNotSubmitted
                ? this.getWritingCreateData()
                : this.getNullStateData()
            }
            getLaunchUrl={this.props.getLaunchUrl}
          />
        ) : (
          <InsightCard
            isReflection
            onTabChange={this.props.onTabChange}
            url="reports/type/reflections"
            textDescription={reflectionDescription}
            textButton={reflectionBtnLabel}
            number={`${
              Math.round(
                (reflectionCard.disagree / reflectionCard.total) * 100
              ) || 0
            }`}
          />
        )}
        {!nullStateAssignments && (
          <RevisionPlansCard
            onTabChange={this.props.onTabChange}
            data={revisionPlanCard}
          />
        )}
      </div>
    );
  }

  render() {
    const { loading } = this.props;

    const renderedSpinner = <Spinner className={s.spinner} />;
    return loading ? renderedSpinner : this.renderInsights();
  }
}

SkillsOverviewWidget.propTypes = {
  id: string,
  onTabChange: func,
  reports: object,
  courseAbstract: object,
  loading: bool,
  getLaunchUrl: func,
};

function mapStateToProps(state) {
  return {
    backPages: state.backPages,
    reports: state.reports,
    loading:
      !state.reports.courseAbstract ||
      state.reports.courseAbstract.loading ||
      !state.reports.overviewWidget ||
      state.reports.overviewWidget.loading,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ refreshReport: refreshReportAction }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SkillsOverviewWidget
);
